import React from 'react';
import { observer } from 'mobx-react';
import Button from 'core/components/Button';

const CreateSavedViewButton = ({ showButtonText, onCreateSavedView, buttonProps }) => (
  <Button {...buttonProps} icon="floppy-disk" onClick={onCreateSavedView} text={showButtonText ? 'Save View' : null} />
);

export default observer(CreateSavedViewButton);
